import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IProjectDashboardOutputModel, IProjectDocDashboardOutputModel, IHomeDashboardInputModel } from 'src/app/ViewModel/DashboardModel';
import { DashboardService } from 'src/app/Service/dashboard/dashboard.service';
import { CommonService } from 'src/app/Service/Common.service';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { LoaderService } from 'src/app/Service/Loader/loader.service';
import { SeriesLabelsVisualArgs } from '@progress/kendo-angular-charts';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from 'src/app/Service/notification.service';
import { C, } from '@angular/cdk/keycodes';
import { CircleProgressComponent, CircleProgressOptions } from 'ng-circle-progress';
import * as L from 'leaflet';
import { HttpClient } from '@angular/common/http';
import { ScheduleDocumentViewPopupComponent } from '../schedule-document-view-popup/schedule-document-view-popup.component';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
const iconRetinaUrl = 'assets/marker-icon-2x.png';
const iconUrl = 'assets/marker-icon.png';
const shadowUrl = 'assets/marker-shadow.png';
const iconDefault = L.icon({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41]
});
L.Marker.prototype.options.icon = iconDefault;

@Component({
  selector: 'app-dashboard-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit, OnDestroy, AfterViewInit {
  //dashboardDetails: IProjectDashboardOutputModel;
  latitude: number = 0;
  longitude: number = 0;
  isDataLoaded: number = 0;
  isMapLoaded: number = 0;
  subscriptions: Subscription[] = []
  Active_Projects: number = 0;
  oldDashboardActive: boolean = false;
  Repository_Documents: number = 0;
  Total_Repository_Documents: number = 0;
  Shared_Documents: number = 0;
  Scheduled_Documents: number = 0;
  Total_Scheduled_Documents: number = 0;
  WF_Pending_Documents: number = 0;
  WF_Assigned_Documents: number = 0;
  WF_Yet_To_Start: number = 0;
  Inbox_Count: number = 0;
  Sent_Count: number = 0;
  projectId!: number;
  groupId!: number;
  memberId!: number;
  projectDocDetails: IProjectDocDashboardOutputModel[] = [];
  projectDocStatusDetails: IProjectDocDashboardOutputModel[] = [];
  projectCommunicationDetails: IProjectDocDashboardOutputModel[] = [];
  projectCommunicationStatusDetails: IProjectDocDashboardOutputModel[] = [];
  projectCommunicationSentStatusDetails: IProjectDocDashboardOutputModel[] = [];
  projectCommunicationInboxStatusDetails: IProjectDocDashboardOutputModel[] = [];
  projectScheduleDetails: IProjectDocDashboardOutputModel[] = [];
  projectDocScheduleDetails: IProjectDocDashboardOutputModel[] = [];
  scheduleCount: number = 0;
  scheduleStatusCount: number = 0;
  documentCount: number = 0;
  documentStatusCount: number = 0;
  communicationCount: number = 0;
  communicationInboxCount: number = 0;
  communicationSentCount: number = 0;
  ViewScheduleDocumentDetails: boolean = false;
  ViewRepositoryDocumentDetails: boolean = false;
  MapDashboardView: boolean=false;

  formDashboard: FormGroup;
  colorCodes: any[] = ['#F6BE00', '#0202FA', '#FF5F15', '#FA0202', '#AA7C7A', '#008000'];
  stageColors: Map<string, string> = new Map<string, string>();
  MasterDetails: any[] = [];
  RepositoryDocumentDetails: any[] | null = [];
  ScheduleDocumentDetails: any[] | null = [];
  GridAPageSize = 15;
  GridASkip = 0;
  GridAEnableFilter = false;
  GridBPageSize = 15;
  GridBSkip = 0;
  GridBEnableFilter = false;
  SelectedProject!: number;
  SelectedGroup!: number;
  ScheduleAdherenceDetails: any[] | null = [];
  MonthWiseDocStatusReport: any[] | null = [];
  category: string[] = [];
  ScheduleDocumentStatusSummary: any[] | null = [];
  DocumentRevisionForGFC: any[] | null = [];
  DocStatusCount: any[] | null = [];
  AvarageTATPerDrawingDetails: any[] | null = [];
  AvarageTATPerDrawing: string = '';
  AvarageTATPerDrawingToottip: string = 'TAT';
  RepositoryDocumentStatusSummary: any[] | null = [];
  MonthWiseRepositoryDocStatusReport: any[] | null = [];
  RepositoryDocumentsCount: number = 0;
  ScheduleDocumentsCount: number = 0;

  GFCchartHeight: number = 430;
  ApprovalStatusCountchartHeight: number = 430;

  panelOpenState: boolean = true;
  IsCorporateHead: boolean = false;
  IsICHead: boolean = false;
  IsISDorEDMScoordinator: boolean = false;
  canShowProjectDashboard: boolean = false;

  PlannedManHrs: string = "Planned Man hours <br><b>0 hrs</b>";
  ActualManHrs: string = "Actual Man hours <br><b>0 hrs</b>";
  PlannedManHrsPercent: number = 0;
  UserEIPICDetails!: string;

  enableFullscreenForDeviationInManhours = false;
  enableFullscreenForDCIStatus = false;
  enableFullscreenForScheduleAdherance = false;
  enableFullscreenForMonthWiseDOCStatus = false;
  enableFullscreenForDocumentRevisionforGFC = false;
  enableFullscreenForApprovalStatusCount = false;
  enableFullscreenForRepositoryDocStatus = false;
  enableFullscreenForRepositoryMonthWiseDocument = false;
  enableFullscreenForRepositoryDocumentDetails = false;
  enableFullscreenForScheduleDocumentDetails = false;
  enableFullscreenForMap = false;
  private map: any;

  @ViewChild('circleProgress')
  circleProgress!: CircleProgressComponent;
  options = new CircleProgressOptions();
  optionsE = {
    radius: 113,
    outerStrokeWidth: 30,
    innerStrokeWidth: 30,
    space: -30,
    outerStrokeColor: "#B4BDED",
    innerStrokeColor: "#DDDDDD",
    showBackground: false,
    titleColor: '#03198b',
    titleFontWeight: 500,
    titleFontSize: 40,
    showSubtitle: false,
    animateTitle: false,
    showUnits: false,
    clockwise: true,
    animation: true,
    animationDuration: 1000,
    startFromZero: true,
    outerStrokeGradient: true,
    outerStrokeGradientStopColor: '#6D78B3',
    lazy: true,
  }

  SelectedICs: number[] = [];
  SelectedProjects: any[] = [];
  SelectedGroups: any[] = [];
  SelectedDisciplines: any[] = [];

  ICDetails: any[] = [];
  ProjectDetails: any[] = [];
  BGDetails: any[] = [];
  DisciplineDetails: any[] = [];

  selectedOption: string = 'schedule';
  public value = 75;
  public chunks = 5;
  public clearValue: string = "N";
  public center: string = "center";
  public dynamicHeight = true;
  constructor(private _dashboardService: DashboardService, private _commonService: CommonService, private loaderService: LoaderService, private _formBuilder: FormBuilder, private _notificationService: NotificationService, private http: HttpClient,private dialog: MatDialog) {
    this.formDashboard = this._formBuilder.group({
      ic: new FormControl(''),
      formIC: new FormControl(''),
      project: new FormControl(''),
      formProject: new FormControl(''),
      bg: new FormControl(''),
      formBG: new FormControl(''),
      discipline: new FormControl(''),
      formDiscipline: new FormControl(''),
    });
  }
  
  ngAfterViewInit(): void {
    
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  async ngOnInit() {
    this.stageColors.set('For Action', this.colorCodes[0]).set('Approved', this.colorCodes[1]).set('Rejected', this.colorCodes[2]).set('In Progress', this.colorCodes[3]).set('On Hold', this.colorCodes[4]).set('Completed', this.colorCodes[5]);
    this.memberId = this._commonService.getLoggedInUserId();

    this.subscriptions.push(await this._commonService.selectedProjectId.subscribe(async data => {
      if (data) {
        this.projectId = data;
        this.groupId = this._commonService.getLoggedInUserGroupId();
        this.SelectedProject = data == 9999999 ? -1 : data;
        this.SelectedGroup = data == 9999999 ? -1 : this._commonService.getLoggedInUserGroupId();

        if (this.SelectedProject == -1) {
          this.subscriptions.push(await this._commonService.getProjectMemberFeatures(null, this.memberId, null, null).subscribe((res: any[]) => {

            this.canShowProjectDashboard = res.some(data => data.feature_Desc.trim().toUpperCase() == 'Project Dashboard'.trim().toUpperCase());
            this.panelOpenState = !this.canShowProjectDashboard
          }));

          this.subscriptions.push(await this._commonService.getProjectMemberRoles(null, null, this.memberId, null).subscribe(async (res: any[]) => {

            if (res.some(data => data.role_Desc.trim().toUpperCase() == 'Corporate Head'.trim().toUpperCase()))
              this.IsCorporateHead = res.some(data => data.role_Desc.trim().toUpperCase() == 'Corporate Head'.trim().toUpperCase());
            else if (res.some(data => data.role_Desc.trim().toUpperCase() == 'IC Head'.trim().toUpperCase()))
              this.IsICHead = res.some(data => data.role_Desc.trim().toUpperCase() == 'IC Head'.trim().toUpperCase());

            if (this.IsICHead)
              this.subscriptions.push(await this._commonService.getMemberICs(this.memberId).subscribe((res: any[]) => {
                if (res) {
                  this.UserEIPICDetails = res.map(x => x.iC_Id).join(",");
                  this.LoadEDMSHomeDashboardDetails();
                }
                else
                  this.LoadEDMSHomeDashboardDetails();
              }));
            else
              this.LoadEDMSHomeDashboardDetails();
          }));
        }
        else {
          this.subscriptions.push(await this._commonService.getProjectMemberFeatures(this.projectId, this.memberId, this.groupId).subscribe((res: any[]) => {

            this.canShowProjectDashboard = res.some(data => data.feature_Desc.trim().toUpperCase() == 'Project Dashboard'.trim().toUpperCase());
            this.panelOpenState = !this.canShowProjectDashboard
          }));

          this.subscriptions.push(await this._commonService.getProjectMemberRoles(this.projectId, this.groupId, this.memberId).subscribe(async (res: any[]) => {

            if (res.some(data => data.role_Desc.trim().toUpperCase() == 'Corporate Head'.trim().toUpperCase()))
              this.IsCorporateHead = res.some(data => data.role_Desc.trim().toUpperCase() == 'Corporate Head'.trim().toUpperCase());
            else if (res.some(data => data.role_Desc.trim().toUpperCase() == 'IC Head'.trim().toUpperCase()))
              this.IsICHead = res.some(data => data.role_Desc.trim().toUpperCase() == 'IC Head'.trim().toUpperCase());
            else if (res.some(data => data.role_Desc.trim().toUpperCase() == 'ISD'.trim().toUpperCase()) || res.some(data => data.role_Desc.trim().toUpperCase() == 'EDMS Coordinator'.trim().toUpperCase()))
              this.IsISDorEDMScoordinator = (res.some(data => data.role_Desc.trim().toUpperCase() == 'ISD'.trim().toUpperCase()) || res.some(data => data.role_Desc.trim().toUpperCase() == 'EDMS Coordinator'.trim().toUpperCase()));

            if (this.IsICHead)
              this.subscriptions.push(await this._commonService.getMemberICs(this.memberId).subscribe((res: any[]) => {
                if (res) {
                  this.UserEIPICDetails = res.map(x => x.iC_Id).join(",");
                  this.LoadEDMSHomeDashboardDetails();
                }
                else
                  this.LoadEDMSHomeDashboardDetails();
              }));
            else
              this.LoadEDMSHomeDashboardDetails();
          }));
        }
      }
    }));
  }

  copyOptions = (event: any, options: any) => {
    this.options = Object.assign({}, this.circleProgress.defaultOptions, options);
  }

  get isRepository(): boolean {
    return this.selectedOption === 'repository';
  };

  changeButtonToggle(event: { value: string; }) {
    this.selectedOption = event.value;
  }

  public labelContent(e: any): string {
    return e.category;
  }

  public labelContentStyleA(e: any): string {
    return e.category + ' : ' + e.value;
  }

  toggleFilter(event: any) {
    switch (event.target.id) {
      case 'GridAFilter':
        this.GridAEnableFilter = !this.GridAEnableFilter;
        break;
      case 'GridBFilter':
        this.GridBEnableFilter = !this.GridBEnableFilter;
        break;
    }
  }

  getStageColor(currentStage: string) {
    if (!!currentStage && this.stageColors.has(currentStage)) {
      return this.stageColors.get(currentStage);
    }
    return null;
  }

  public labelVisual(args: SeriesLabelsVisualArgs): Element {
    const label: any = args.createVisual();
    label.options.set('cursor', 'pointer');
    return label;
  }

  collapseAllClick() {
    this.panelOpenState = !this.panelOpenState;
  }

  private GetAutoCompleteValues(text: string, value: string, source: any[]): any {
    const result = [];
    const map = new Map();
    for (const item of source) {
      if (!map.has(item[value]) && item[value]) {
        map.set(item[value], true);    // set any value to Map
        result.push({
          key: item[value],
          value: item[text]
        });
      }
    }
    return result;
  }

  onSelectedValueChange(event: any, formGroupName: string, formControlName: string) {
    let O: any[] = event.emittingList.map((x: { value: any; }) => ({ value: x.value }));

    switch (formControlName) {
      case 'ic':
        this.SelectedICs = event.emittingList.map((x: { value: string | number; }) => +x.value);

        this.ProjectDetails = [];
        this.SelectedProjects = [];

        if (O.length > 0)
          this.ProjectDetails = this.GetAutoCompleteValues('project_Id', 'project', this.MasterDetails.filter(({ iC_Id: iCId }) => O.some(({ value: val }) => iCId == val)));
        else
          this.ProjectDetails = this.GetAutoCompleteValues('project_Id', 'project', this.MasterDetails);

        if (this.SelectedProject != -1)
          this.SelectedProjects = this.ProjectDetails.map(x => +x.value);

        this.BGDetails = [];
        this.SelectedGroups = [];

        if (O.length > 0)
          this.BGDetails = this.GetAutoCompleteValues('group_Id', 'group', this.MasterDetails.filter(({ iC_Id: iCId }) => this.SelectedICs.map((str, index) => ({ value: str })).some(({ value: val }) => iCId == val)));
        else if (O.length == 0 && this.SelectedICs.length == 0)
          this.BGDetails = this.GetAutoCompleteValues('group_Id', 'group', this.MasterDetails);

        if (this.SelectedProject != -1)
          this.SelectedGroups = this.BGDetails.map(x => +x.value);

        this.DisciplineDetails = [];
        this.SelectedDisciplines = [];

        if (O.length > 0)
          this.DisciplineDetails = this.GetAutoCompleteValues('discipline_Id', 'discipline', this.MasterDetails.filter(({ iC_Id: iCId }) => this.SelectedICs.map((str, index) => ({ value: str })).some(({ value: val }) => iCId == val)));
        else if (O.length == 0)
          this.DisciplineDetails = this.GetAutoCompleteValues('discipline_Id', 'discipline', this.MasterDetails);

        if (this.SelectedProject != -1)
          this.SelectedDisciplines = this.DisciplineDetails.map(x => +x.value);

        break;
      case 'project':
        this.SelectedProjects = event.emittingList.map((x: { value: string | number; }) => +x.value);
        let src = this.MasterDetails.filter(({ iC_Id: iCId }) => this.SelectedICs.map((str, index) => ({ value: str })).some(({ value: val }) => iCId == val)).filter(({ project_Id: projectId }) => this.SelectedProjects.map((str, index) => ({ value: str })).some(({ value: val }) => projectId == val));

        this.BGDetails = [];
        this.SelectedGroups = [];

        if (O.length > 0)
          this.BGDetails = this.GetAutoCompleteValues('group_Id', 'group', src);
        else if (O.length == 0 && this.SelectedICs.length > 0)
          this.BGDetails = this.GetAutoCompleteValues('group_Id', 'group', this.MasterDetails.filter(({ iC_Id: iCId }) => this.SelectedICs.map((str, index) => ({ value: str })).some(({ value: val }) => iCId == val)));
        else if (O.length == 0 && this.SelectedICs.length == 0)
          this.BGDetails = this.GetAutoCompleteValues('group_Id', 'group', this.MasterDetails);

        if (this.SelectedProject != -1)
          this.SelectedGroups = this.BGDetails.map(x => +x.value);

        this.DisciplineDetails = [];
        this.SelectedDisciplines = [];

        if (O.length > 0)
          this.DisciplineDetails = this.GetAutoCompleteValues('discipline_Id', 'discipline', this.MasterDetails.filter(({ iC_Id: iCId }) => this.SelectedICs.map((str, index) => ({ value: str })).some(({ value: val }) => iCId == val)).filter(({ project_Id: projectId }) => this.SelectedProjects.map((str, index) => ({ value: str })).some(({ value: val }) => projectId == val)));
        else if (O.length == 0 && this.SelectedICs.length > 0)
          this.DisciplineDetails = this.GetAutoCompleteValues('discipline_Id', 'discipline', this.MasterDetails.filter(({ iC_Id: iCId }) => this.SelectedICs.map((str, index) => ({ value: str })).some(({ value: val }) => iCId == val)));
        else if (O.length == 0)
          this.DisciplineDetails = this.GetAutoCompleteValues('discipline_Id', 'discipline', this.MasterDetails);

        if (this.SelectedProject != -1)
          this.SelectedDisciplines = this.DisciplineDetails.map(x => +x.value);
        break;
      case 'bg':
        this.SelectedGroups = event.emittingList.map((x: { value: string | number; }) => +x.value);
        let bgsrc = this.MasterDetails.filter(({ iC_Id: iCId }) => this.SelectedICs.map((str, index) => ({ value: str })).some(({ value: val }) => iCId == val)).filter(({ project_Id: projectId }) => this.SelectedProjects.map((str, index) => ({ value: str })).some(({ value: val }) => projectId == val)).filter(({ group_Id: groupId }) => this.SelectedGroups.map((str, index) => ({ value: str })).some(({ value: val }) => groupId == val));

        this.DisciplineDetails = [];
        this.SelectedDisciplines = [];

        if (O.length > 0)
          this.DisciplineDetails = this.GetAutoCompleteValues('discipline_Id', 'discipline', bgsrc);
        else if (O.length == 0 && this.SelectedICs.length > 0 && this.SelectedProjects.length > 0)
          this.DisciplineDetails = this.GetAutoCompleteValues('discipline_Id', 'discipline', this.MasterDetails.filter(({ iC_Id: iCId }) => this.SelectedICs.map((str, index) => ({ value: str })).some(({ value: val }) => iCId == val)).filter(({ project_Id: projectId }) => this.SelectedProjects.map((str, index) => ({ value: str })).some(({ value: val }) => projectId == val)));
        else if (O.length == 0 && this.SelectedICs.length > 0)
          this.DisciplineDetails = this.GetAutoCompleteValues('discipline_Id', 'discipline', this.MasterDetails.filter(({ iC_Id: iCId }) => this.SelectedICs.map((str, index) => ({ value: str })).some(({ value: val }) => iCId == val)));
        else if (O.length == 0)
          this.DisciplineDetails = this.GetAutoCompleteValues('discipline_Id', 'discipline', this.MasterDetails);

        if (this.SelectedProject != -1)
          this.SelectedDisciplines = this.DisciplineDetails.map(x => +x.value);
        break;
      case 'discipline':
        this.SelectedDisciplines = event.emittingList.map((x: { value: string | number; }) => +x.value);
        break;
    }
  }

  setFormValue(form: FormGroup, formControlName: string, value: any) {
    form.get(formControlName)?.setValue(value);
  }

  private getFormValue(form: FormGroup, formControlName: string): any {
    return form.get(formControlName)?.value;
  }

  async LoadEDMSHomeDashboardDetails() {
    let x: IHomeDashboardInputModel = {
      tran_Type: 'MasterDetails',
      userId: this.memberId,
      isLatestRevision: true,
      iCId: this.SelectedProject == -1 && this.IsICHead && this.UserEIPICDetails ? this.UserEIPICDetails : null,
      projectId: this.SelectedProject == -1 ? null : this.SelectedProject.toString(),
      groupId: this.SelectedGroup == -1 || this.IsCorporateHead || this.IsICHead || this.IsISDorEDMScoordinator ? null : this.SelectedGroup.toString(),
      isSuperUser: this.SelectedProject == -1 ? this.IsCorporateHead || (this.IsICHead && this.UserEIPICDetails.length > 0) : this.IsCorporateHead || this.IsICHead || this.IsISDorEDMScoordinator
    }

    this.subscriptions.push(await this._dashboardService.GetEDMSHomeDashboardDetails(x).subscribe(async t => {
      this.MasterDetails = t;

      this.ICDetails = this.GetAutoCompleteValues('iC_Id', 'ic', this.MasterDetails)
      this.ProjectDetails = this.GetAutoCompleteValues('project_Id', 'project', this.MasterDetails)
      this.BGDetails = this.GetAutoCompleteValues('group_Id', 'group', this.MasterDetails)
      this.DisciplineDetails = this.GetAutoCompleteValues('discipline_Id', 'discipline', this.MasterDetails)

      if (this.SelectedProject == -1) {
        this.SelectedICs = [];
        this.SelectedProjects = [];
        this.SelectedGroups = [];
        this.SelectedDisciplines = [];

        this.RepositoryDocumentDetails = null;
        this.ScheduleDocumentDetails = null;
        this.ScheduleAdherenceDetails = null;
        this.MonthWiseDocStatusReport = null;
        this.ScheduleDocumentStatusSummary = null;
        this.DocumentRevisionForGFC = null;
        this.DocStatusCount = null;
        this.AvarageTATPerDrawingDetails = null;
        this.AvarageTATPerDrawing = "0";
        this.AvarageTATPerDrawingToottip = '';
        this.PlannedManHrs = "Planned Man hours <br><b>0 hrs</b>";
        this.ActualManHrs = "Actual Man hours <br><b>0 hrs</b>";
        this.PlannedManHrsPercent = 0;
        this.RepositoryDocumentStatusSummary = null;
        this.MonthWiseRepositoryDocStatusReport = null;
        this.RepositoryDocumentsCount = 0;
        this.ScheduleDocumentsCount = 0;
        this.RepositoryDocumentStatusSummary = null;
        this.MonthWiseRepositoryDocStatusReport = null;
        this.RepositoryDocumentsCount = 0;
        this.ScheduleDocumentsCount = 0;

        const message = {
          messageSeverity: '3',
          messageText: 'Select Values to Load Dashboard !!!',
        };
        this._notificationService.showPopupMessageBox(message);
      } else {
        this.SelectedICs = this.GetAutoCompleteValues('iC_Id', 'ic', this.MasterDetails).map((x: { value: any; }) => x.value);
        this.SelectedProjects = this.GetAutoCompleteValues('project_Id', 'project', this.MasterDetails).map((x: { value: any; }) => x.value);
        this.SelectedGroups = this.GetAutoCompleteValues('group_Id', 'group', this.MasterDetails).map((x: { value: any; }) => x.value);
        this.SelectedDisciplines = this.GetAutoCompleteValues('discipline_Id', 'discipline', this.MasterDetails).map((x: { value: any; }) => x.value);

        await this.ReloadDashBoard('');
      }
    }))
  }

  LoadScheduleDocuments() {
    this.ViewScheduleDocumentDetails = !this.ViewScheduleDocumentDetails;

    if (!(this.ScheduleDocumentDetails && this.ScheduleDocumentDetails.length > 0)) {
      let ICIds: string | null = this.SelectedICs && this.SelectedICs.length > 0 ? this.SelectedICs.map(x => x).join(",") : null;
      let ProjectIds: string | null = this.SelectedProjects && this.SelectedProjects.length > 0 ? this.SelectedProjects.map(x => x).join(",") : null;
      let GroupIds: string | null = this.SelectedGroups && this.SelectedGroups.length > 0 ? this.SelectedGroups.map(x => x).join(",") : null;
      let DisciplineIds: string | null = this.SelectedDisciplines && this.SelectedDisciplines.length > 0 ? this.SelectedDisciplines.map(x => x).join(",") : null;
      let objSuperUser: boolean = this.SelectedProject == -1 ? this.IsCorporateHead || (this.IsICHead && this.UserEIPICDetails.length > 0) : this.IsCorporateHead || this.IsICHead || this.IsISDorEDMScoordinator;


      this._dashboardService.GetEDMSHomeDashboardDetails({
        tran_Type: 'ScheduleDocumentDetails',
        userId: this.memberId,
        isLatestRevision: true,
        iCId: ICIds,
        projectId: ProjectIds,
        groupId: GroupIds,
        disciplineId: DisciplineIds,
        isSuperUser: objSuperUser
      }).subscribe(async res => {
        if (res && res.length > 0) {
          this.ScheduleDocumentDetails = res;
        }
      });
    }
  }

  LoadRepositoryDocuments() {
    this.ViewRepositoryDocumentDetails = !this.ViewRepositoryDocumentDetails;

    if (!(this.RepositoryDocumentDetails && this.RepositoryDocumentDetails.length > 0)) {
      let ICIds: string | null = this.SelectedICs && this.SelectedICs.length > 0 ? this.SelectedICs.map(x => x).join(",") : null;
      let ProjectIds: string | null = this.SelectedProjects && this.SelectedProjects.length > 0 ? this.SelectedProjects.map(x => x).join(",") : null;
      let GroupIds: string | null = this.SelectedGroups && this.SelectedGroups.length > 0 ? this.SelectedGroups.map(x => x).join(",") : null;
      let DisciplineIds: string | null = this.SelectedDisciplines && this.SelectedDisciplines.length > 0 ? this.SelectedDisciplines.map(x => x).join(",") : null;
      let objSuperUser: boolean = this.SelectedProject == -1 ? this.IsCorporateHead || (this.IsICHead && this.UserEIPICDetails.length > 0) : this.IsCorporateHead || this.IsICHead || this.IsISDorEDMScoordinator;

      this._dashboardService.GetEDMSHomeDashboardDetails({
        tran_Type: 'RepositoryDocumentDetails',
        userId: this.memberId,
        isLatestRevision: true,
        iCId: ICIds,
        projectId: ProjectIds,
        groupId: GroupIds,
        disciplineId: DisciplineIds,
        isSuperUser: objSuperUser
      }).subscribe(async res => {
        if (res && res.length > 0) {
          this.RepositoryDocumentDetails = res;
        }
      });
    }
  }

  async ReloadDashBoard(event: any) {
    this.isDataLoaded = 0;
    this.ViewScheduleDocumentDetails = false;
    this.ViewRepositoryDocumentDetails = false;

    this.RepositoryDocumentDetails = null;
    this.ScheduleDocumentDetails = null;
    this.ScheduleAdherenceDetails = null;
    this.MonthWiseDocStatusReport = null;
    this.ScheduleDocumentStatusSummary = null;
    this.DocumentRevisionForGFC = null;
    this.DocStatusCount = null;
    this.AvarageTATPerDrawingDetails = null;
    this.AvarageTATPerDrawing = "0";
    this.AvarageTATPerDrawingToottip = '';
    this.PlannedManHrs = "Planned Man hours <br><b>0 hrs</b>";
    this.ActualManHrs = "Actual Man hours <br><b>0 hrs</b>";
    this.PlannedManHrsPercent = 0;
    this.RepositoryDocumentStatusSummary = null;
    this.MonthWiseRepositoryDocStatusReport = null;
    this.RepositoryDocumentsCount = 0;
    this.ScheduleDocumentsCount = 0;
    this.RepositoryDocumentStatusSummary = null;
    this.MonthWiseRepositoryDocStatusReport = null;
    this.RepositoryDocumentsCount = 0;
    this.ScheduleDocumentsCount = 0;

    let ICIds: string | null = this.SelectedICs && this.SelectedICs.length > 0 ? this.SelectedICs.map(x => x).join(",") : null;
    let ProjectIds: string | null = this.SelectedProjects && this.SelectedProjects.length > 0 ? this.SelectedProjects.map(x => x).join(",") : null;
    let GroupIds: string | null = this.SelectedGroups && this.SelectedGroups.length > 0 ? this.SelectedGroups.map(x => x).join(",") : null;
    let DisciplineIds: string | null = this.SelectedDisciplines && this.SelectedDisciplines.length > 0 ? this.SelectedDisciplines.map(x => x).join(",") : null;
    let objSuperUser: boolean = this.SelectedProject == -1 ? this.IsCorporateHead || (this.IsICHead && this.UserEIPICDetails.length > 0) : this.IsCorporateHead || this.IsICHead || this.IsISDorEDMScoordinator;

    if (!!this.SelectedProject && this.SelectedProject != 9999999 && ProjectIds == null) {
      const message = {
        messageSeverity: '3',
        messageText: 'Select Values to Load Dashboard !!!',
      };
      this._notificationService.showPopupMessageBox(message);
      return;
    }

    this.subscriptions.push(this._dashboardService.GetEDMSHomeDashboardDetails({
      tran_Type: 'UserDashboardDetails',
      userId: this.memberId,
      isLatestRevision: true,
      iCId: ICIds,
      projectId: ProjectIds,
      groupId: GroupIds,
      disciplineId: DisciplineIds,
      isSuperUser: objSuperUser
    }).subscribe(async res => {
      if (res) {
        this.oldDashboardActive = true;
        this.Active_Projects = res.activeProjects;
        this.Repository_Documents = res.myRepositoryDocuments;
        this.Total_Repository_Documents = res.totalRepositoryDocuments;
        this.Shared_Documents = res.sharedRepositoryDocuments;
        this.Scheduled_Documents = res.myScheduleDocuments;
        this.Total_Scheduled_Documents = res.totalScheduleDocuments;
        this.WF_Pending_Documents = res.wfActionPendingDocuments;
        this.WF_Yet_To_Start = res.wfYetToStartDocuments;
        this.Inbox_Count = res.communicationInbox;
        this.Sent_Count = res.communicationSent;
        this.WF_Assigned_Documents = res.wfActionTakenDocuments;
      }
    }));

    if (this.canShowProjectDashboard) {
      let objAvarageTATPerDrawing: Observable<any[]> = this._dashboardService.GetEDMSHomeDashboardDetails({
        tran_Type: 'AvarageTATPerDrawing',
        userId: this.memberId,
        isLatestRevision: true,
        iCId: ICIds,
        projectId: ProjectIds,
        groupId: GroupIds,
        disciplineId: DisciplineIds,
        isSuperUser: objSuperUser
      });

      let objDeviationManhours: Observable<any[]> = this._dashboardService.GetEDMSHomeDashboardDetails({
        tran_Type: 'DeviationManhours',
        userId: this.memberId,
        isLatestRevision: true,
        iCId: ICIds,
        projectId: ProjectIds,
        groupId: GroupIds,
        disciplineId: DisciplineIds,
        isSuperUser: objSuperUser
      });

      let objScheduleDocumentStatusSummary: Observable<any[]> = this._dashboardService.GetEDMSHomeDashboardDetails({
        tran_Type: 'ScheduleDocumentStatusSummary',
        userId: this.memberId,
        isLatestRevision: true,
        iCId: ICIds,
        projectId: ProjectIds,
        groupId: GroupIds,
        disciplineId: DisciplineIds,
        isSuperUser: objSuperUser
      });

      let objScheduleAdherence: Observable<any[]> = this._dashboardService.GetEDMSHomeDashboardDetails({
        tran_Type: 'ScheduleAdherence',
        userId: this.memberId,
        isLatestRevision: true,
        iCId: ICIds,
        projectId: ProjectIds,
        groupId: GroupIds,
        disciplineId: DisciplineIds,
        isSuperUser: objSuperUser
      });

      let objMonthWiseDocStatusReport: Observable<any[]> = this._dashboardService.GetEDMSHomeDashboardDetails({
        tran_Type: 'MonthWiseDocStatusReport',
        userId: this.memberId,
        isLatestRevision: true,
        iCId: ICIds,
        projectId: ProjectIds,
        groupId: GroupIds,
        disciplineId: DisciplineIds,
        isSuperUser: objSuperUser
      });

      let objDocumentRevisionForGFC: Observable<any[]> = this._dashboardService.GetEDMSHomeDashboardDetails({
        tran_Type: 'DocumentRevisionForGFC',
        userId: this.memberId,
        isLatestRevision: true,
        iCId: ICIds,
        projectId: ProjectIds,
        groupId: GroupIds,
        disciplineId: DisciplineIds,
        isSuperUser: objSuperUser
      });

      let objDocStatusCount: Observable<any[]> = this._dashboardService.GetEDMSHomeDashboardDetails({
        tran_Type: 'DocStatusCount',
        userId: this.memberId,
        isLatestRevision: true,
        iCId: ICIds,
        projectId: ProjectIds,
        groupId: GroupIds,
        disciplineId: DisciplineIds,
        isSuperUser: objSuperUser
      });

      let objRepositoryDocumentStatusSummary: Observable<any[]> = this._dashboardService.GetEDMSHomeDashboardDetails({
        tran_Type: 'RepositoryDocumentStatusSummary',
        userId: this.memberId,
        isLatestRevision: true,
        iCId: ICIds,
        projectId: ProjectIds,
        groupId: GroupIds,
        disciplineId: DisciplineIds,
        isSuperUser: objSuperUser
      });

      let objMonthWiseRepositoryDocStatusReport: Observable<any[]> = this._dashboardService.GetEDMSHomeDashboardDetails({
        tran_Type: 'MonthWiseRepositoryDocStatusReport',
        userId: this.memberId,
        isLatestRevision: true,
        iCId: ICIds,
        projectId: ProjectIds,
        groupId: GroupIds,
        disciplineId: DisciplineIds,
        isSuperUser: objSuperUser
      });

      let objRepositoryDocumentsCount: Observable<any[]> = this._dashboardService.GetEDMSHomeDashboardDetails({
        tran_Type: 'RepositoryDocumentsCount',
        userId: this.memberId,
        isLatestRevision: true,
        iCId: ICIds,
        projectId: ProjectIds,
        groupId: GroupIds,
        disciplineId: DisciplineIds,
        isSuperUser: objSuperUser
      });

      let objScheduleDocumentsCount: Observable<any[]> = this._dashboardService.GetEDMSHomeDashboardDetails({
        tran_Type: 'ScheduleDocumentsCount',
        userId: this.memberId,
        isLatestRevision: true,
        iCId: ICIds,
        projectId: ProjectIds,
        groupId: GroupIds,
        disciplineId: DisciplineIds,
        isSuperUser: objSuperUser
      });

      let objMapDashboardDetails: Observable<any[]> = this._dashboardService.GetEDMSHomeDashboardDetails({
        tran_Type: 'MapDashboardDetails',
        userId: this.memberId,
        isLatestRevision: true,
        iCId: ICIds,
        projectId: ProjectIds,
        groupId: GroupIds,
        disciplineId: DisciplineIds,
        isSuperUser: objSuperUser
      });

      this.subscriptions.push(forkJoin(objAvarageTATPerDrawing, objDeviationManhours, objScheduleDocumentStatusSummary, objScheduleAdherence, objMonthWiseDocStatusReport, objDocumentRevisionForGFC, objDocStatusCount, objRepositoryDocumentStatusSummary, objMonthWiseRepositoryDocStatusReport, objRepositoryDocumentsCount, objScheduleDocumentsCount, objMapDashboardDetails).subscribe((res: any[]) => {
        this.isDataLoaded = 1;
        if (res[0].length > 0) {
          this.AvarageTATPerDrawingDetails = res[0];
          this.AvarageTATPerDrawing = this.AvarageTATPerDrawingDetails[0].tat;
          this.AvarageTATPerDrawingToottip = this.AvarageTATPerDrawingDetails[0].tooltip;
        }

        if (res[1].length > 0) {
          this.ActualManHrs = "Actual Man hours <br><b>" + res[1][0].actual + " hrs</b>";
          this.PlannedManHrs = "Planned Man hours <br><b>" + res[1][0].planned + " hrs</b>";
          this.PlannedManHrsPercent = res[1][0].deviationPercentage;
        }

        if (res[2].length > 0)
          this.ScheduleDocumentStatusSummary = res[2];

        if (res[3].length > 0)
          this.ScheduleAdherenceDetails = res[3];

        if (res[4].length > 0)
          this.MonthWiseDocStatusReport = res[4];

        if (res[5].length > 0) {
          this.GFCchartHeight = res[5].length * 30 < 430 ? 430 : res[5].length * 30;
          this.DocumentRevisionForGFC = res[5];
        }

        if (res[6].length > 0) {
          this.ApprovalStatusCountchartHeight = res[6].length * 30 < 430 ? 430 : res[6].length * 30;
          this.DocStatusCount = res[6];
        }

        if (res[7].length > 0)
          this.RepositoryDocumentStatusSummary = res[7];

        if (res[8].length > 0)
          this.MonthWiseRepositoryDocStatusReport = res[8];

        if (res[9])
          this.RepositoryDocumentsCount = res[9].docCount;

        if (res[10])
          this.ScheduleDocumentsCount = res[10].docCount;

        if (res[11].length > 1) {
          this.MapDashboardView=true;
          this.initMap();
          this.makeCapitalMarkers(this.map, res[11]);
          

        } else if (res[11].length == 1) {
          this.MapDashboardView=true;
          this.latitude = res[11][0].latitude;
          this.longitude = res[11][0].longitude;
          this.initMap();
          this.makeCapitalMarkers(this.map, res[11]);
          this.zoomToState(this.latitude, this.longitude);
          
        }
      }
      ));



    }
  }
  private initMap(): void {
    this.map = L.map('map', {
      center: [26.9124336, 75.7872709],
      zoom: 4
    });

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      minZoom: 3,

    });

    tiles.addTo(this.map);
  }
  zoomToState(lat: number, long: number) {
    this.map.setView([lat, long], 7);

  }

  makeCapitalMarkers(map: L.Map, res: any[]): void {
    for (const c of res) {
      const lat = c.latitude;
      const lon = c.longitude;
      const marker = L.marker([lat, lon]);
      marker.addTo(map);
      let url: any = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`;
      this.http.get(url).subscribe((x: any) => {
        marker.bindPopup(this.makeCapitalPopup(x, c.tooltip));
      })
      marker.on('mouseover', () => {
        marker.openPopup();
      });
      marker.on('mouseout', () => {
        marker.closePopup();
      });
      

    }
    
    
  }
  makeCapitalPopup(data: any, tooltip: any): string {
    let address = '';
    if (data.address.city) {
      address = data.address.city;
    } else if (data.address.state_district) {
      address = data.address.state_district;
    } else if (data.address.town) {
      address = data.address.town;
    }
    return `` +
      `<div>${address} - ${data.address.postcode}</div>` +
      `<div> ${tooltip}</div>`

  }

  /**
    * Full screen
    */
  toggleFullscreen(chart: string) {
    if (chart == 'DeviationInManhours')
      this.enableFullscreenForDeviationInManhours = !this.enableFullscreenForDeviationInManhours;
    else if (chart == 'DCIStatus')
      this.enableFullscreenForDCIStatus = !this.enableFullscreenForDCIStatus;
    else if (chart == 'ScheduleAdherance')
      this.enableFullscreenForScheduleAdherance = !this.enableFullscreenForScheduleAdherance;
    else if (chart == 'MonthWiseDOCStatus')
      this.enableFullscreenForMonthWiseDOCStatus = !this.enableFullscreenForMonthWiseDOCStatus;
    else if (chart == 'DocumentRevisionforGFC')
      this.enableFullscreenForDocumentRevisionforGFC = !this.enableFullscreenForDocumentRevisionforGFC;
    else if (chart == 'ApprovalStatusCount')
      this.enableFullscreenForApprovalStatusCount = !this.enableFullscreenForApprovalStatusCount;
    else if (chart == 'RepositoryDocStatus')
      this.enableFullscreenForRepositoryDocStatus = !this.enableFullscreenForRepositoryDocStatus;
    else if (chart == 'RepositoryMonthWiseDocument')
      this.enableFullscreenForRepositoryMonthWiseDocument = !this.enableFullscreenForRepositoryMonthWiseDocument;
    else if (chart == 'RepositoryDocumentDetails')
      this.enableFullscreenForRepositoryDocumentDetails = !this.enableFullscreenForRepositoryDocumentDetails;
    else if (chart == 'ScheduleDocumentDetails')
      this.enableFullscreenForScheduleDocumentDetails = !this.enableFullscreenForScheduleDocumentDetails;
    else if (chart == 'MapDashboard')
      this.enableFullscreenForMap = !this.enableFullscreenForMap;


  }

  viewDocumentClick(dataItem)
  {
    console.log(dataItem);
    const dialogRef = this.dialog.open(ScheduleDocumentViewPopupComponent, {
      panelClass: 'mat-dialog-primary',
      width: '90%',
      maxWidth: '90vw',
      data: { doc_id:dataItem.doc_Id,revision_No:dataItem.latest_Rev_Number,approval_date: dataItem.doc_Status == 'Rejected' ? null : dataItem.created_on}
    });
  }
}